import React, { useEffect, useRef, useState } from 'react';
import { format, getWeek, startOfWeek, addDays, previousMonday, nextMonday } from 'date-fns';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Button, ButtonGroup, Popover } from '@mui/material';
import WeekPicker from '../common/WeekPicker';
import intl from 'components/i18n/ReactIntlWrapper';
import { GLOBAL_DATE_CONFIG } from 'common/constants';

interface WeekPickerDialogProps {
    selectedDate: Date
    handleDateChange: Function
    handleInputChange?: any
}
export const getInputValueText = (date: Date) => {
    let week = getWeek(date, { weekStartsOn: 1 });
    let firstDayOfWeek = startOfWeek(date, { weekStartsOn: 1 });
    let lastDayOfWeek = addDays(firstDayOfWeek, GLOBAL_DATE_CONFIG.WORKING_WEEK_DAYS - 1);
    let firstDateYear = firstDayOfWeek.getFullYear() == lastDayOfWeek.getFullYear() ? '' : " " + firstDayOfWeek.getFullYear();
    let weekMsg = (week == getWeek(new Date(), { weekStartsOn: 1 })) ? intl.get('timesheetComponent.weekPicker.thisWeekLabel') : (intl.get('timesheetComponent.weekPicker.weekLabel') + " "+ week + ", ");
    return weekMsg +" "+ format(firstDayOfWeek, 'MMM dd') + firstDateYear + " - " + format(lastDayOfWeek, 'MMM dd yyyy');
}
const WeekPickerDialog: React.FC<WeekPickerDialogProps> = ({ selectedDate, handleDateChange, handleInputChange }: WeekPickerDialogProps) => {

    const [inputValue, setInputValue] = useState<string>(getInputValueText(selectedDate));
    const [isPopperOpen, setIsPopperOpen] = useState(false);

    const inputButtonRef = useRef<HTMLButtonElement>(null);
    const popperRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
        null
    );

    const closePopper = () => {
        setIsPopperOpen(false);
        buttonRef?.current?.focus();
    };


    const handleInputClick = () => {
        setIsPopperOpen(true);
    };

    const handleDaySelect = (date: Date | undefined) => {

        if (date) {
            let firstDayOfWeek = startOfWeek(date, { weekStartsOn: 1 });
            handleDateChange(firstDayOfWeek);
            setInputValue(getInputValueText(date));
            closePopper();
        } else {
            setInputValue('');
        }
    };
    const prevWeek = () => {
        let preMonday = previousMonday(selectedDate);
        handleDateChange(preMonday);
        setInputValue(getInputValueText(preMonday));
    };
    const nextWeek = () => {
        let preMonday = nextMonday(selectedDate);
        handleDateChange(preMonday);
        setInputValue(getInputValueText(preMonday));
    };

    useEffect(() => {
        setInputValue(getInputValueText(selectedDate));
    }, [selectedDate]);

    //setInputValue(getInputValueText(selectedDate));
    return (<>
        <Box>
            <ButtonGroup variant="outlined" aria-label="Basic button group" color='inherit'>
                <Button
                    ref={buttonRef}
                    type="button"
                    aria-label="Prev Week"
                    onClick={prevWeek}
                >
                    <ArrowBackIcon/>
                </Button>
                <Button ref={inputButtonRef} onClick={handleInputClick}>
                    {inputValue}
                </Button>
                <Button aria-describedby={"calendar-popover"} onClick={handleInputClick}><CalendarMonthIcon/></Button>
                <Popover
                    id={"calendar-popover"}
                    open={isPopperOpen}
                    anchorEl={inputButtonRef.current}
                    onClose={closePopper}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    classes={{ paper: 'px-2' }}
                >
                    <WeekPicker
                        value={selectedDate}
                        onChange={handleDaySelect}
                    />
                </Popover>
                <Button
                    ref={buttonRef}
                    type="button"
                    aria-label="Next Week"
                    onClick={nextWeek}
                >
                    <ArrowForwardIcon/>
                </Button>
            </ButtonGroup>
        </Box>
    </>);
}
export default WeekPickerDialog;